import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { candidatePortalApi } from '../../api/candidatePortal';
import { useCandidateAuth } from './CandidateAuthContext';
import { CareersNav } from './CareersNav';
import { formatDate } from '../../utils/formatDate';

const STATUS_LABELS: Record<string, string> = { applied: 'Applied', screening: 'Screening', shortlisted: 'Shortlisted', interview: 'Interview', selected: 'Selected', offer: 'Offer', hired: 'Hired', rejected: 'Not Selected' };

export function MyApplicationsPage() {
  const { account, loading } = useCandidateAuth();
  const navigate = useNavigate();
  const applicationsQuery = useQuery({ queryKey: ['my-candidate-applications'], queryFn: () => candidatePortalApi.myApplications(), enabled: !!account });

  useEffect(() => { if (!loading && !account) navigate('/careers/login'); }, [loading, account, navigate]);

  if (loading || !account) return <div className="careers-page"><CareersNav /><p className="muted">Loading…</p></div>;

  return (
    <div className="careers-page">
      <CareersNav />
      <h1>My Applications</h1>
      <div className="card">
        {applicationsQuery.data && applicationsQuery.data.data.length === 0 && <p className="muted">You haven't applied to any positions yet.</p>}
        {applicationsQuery.data?.data.map((a) => (
          <div key={a.id} className="p11-repeat-block">
            <strong>{a.position_title ?? 'Position'}</strong> ({a.vacancy_reference})
            <p className="muted">Applied: {formatDate(a.created_at)} · Status: {STATUS_LABELS[a.status] ?? a.status}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
